/**
 * /superadmin/subprocessors — Platform subprocessor register (route shell).
 * Screen impl in `./subprocessors-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/subprocessors')({
  component: lazyRouteComponent(
    () => import('./subprocessors-screen'),
    'SubprocessorsPlaceholder',
  ),
});
